import type { YNode } from "@/models/DocumentModel";
import type { NodeModel, SerializedNode } from "@/models/nodes/types";
import type { NodeJson } from "@corca/data";
import type * as Y from "yjs";

export function prettyPrintNodes(
  nodes: (NodeModel | NodeJson | SerializedNode | Y.Map<YNode[keyof YNode]>)[] = [],
  startIndent = 0,
): string {
  const printNodes = (
    _nodes: (NodeModel | NodeJson | SerializedNode | Y.Map<YNode[keyof YNode]>)[],
    depth: number,
  ): string => {
    const prefix = " ".repeat(2 * depth);
    const count = _nodes.length;
    return _nodes.reduce((acc, nn, idx) => {
      const n = "toJSON" in nn ? (nn.toJSON() as NodeJson) : nn;
      let title = n.type;
      if (n.id) {
        title += `#${n.id}`;
      }
      if ("props" in n && n.type !== "text") {
        const props = Object.entries(n.props).filter(([, val]) => val !== undefined);
        if (props.length > 0) {
          title = `${n.type} (${props.map(([key, val]) => `${key}=${JSON.stringify(val)}`).join(",")})`;
        }
      }
      if (count > 1) {
        title = `${idx}: ${title}`;
      }
      if ("children" in n) {
        return acc.concat(prefix, title, "\n", printNodes(n.children, depth + 1));
      }

      return acc.concat(prefix, title, " ", JSON.stringify(n.childrenIds), "\n");
    }, "");
  };

  return printNodes(nodes, startIndent);
}
